document.addEventListener("DOMContentLoaded", function(){
  const cards = document.querySelectorAll(".product-card__media-link");
  if (!cards.length) return;

  cards.forEach(card => {
    let startY = 0, startX = 0, moved = false;

    card.addEventListener("touchstart", e => {
      startY = e.touches[0].clientY;
      startX = e.touches[0].clientX;
      moved = false;
    });

    card.addEventListener("touchmove", e => {
      const dy = Math.abs(e.touches[0].clientY - startY);
      const dx = Math.abs(e.touches[0].clientX - startX);

      if (dy > 5 && dx < 10 && !moved) {
        const imgs = card.querySelectorAll("img");
        if (imgs.length > 1) {
          imgs[0].classList.remove("is-active");
          imgs[1].classList.add("is-active");
        }
        moved = true;
      }
    });

    card.addEventListener("touchend", () => {
      const imgs = card.querySelectorAll("img");
      if (imgs.length > 1) {
        setTimeout(() => {
          imgs.forEach(img => img.classList.remove("is-active"));
          imgs[0].classList.add("is-active");
        }, 300);
      }

      if (!moved) {
        window.location.href = card.getAttribute("href");
      }
    });
  });
});
